import { DuplicateResolution } from '../components/documents/dedup/dedup.model';

export interface PendingConflict {
  name: string;
  existingId?: number;
  existingSubtypeId?: number;
  resolution?: DuplicateResolution;
}

/** In-flight WS name-collision state shared by DCE and reference-document import. */
export class ImportConflictSession {
  private readonly pending = new Map<string, PendingConflict>();

  get hasPending(): boolean {
    return this.pending.size > 0;
  }

  get(conflictKey: string): PendingConflict | undefined {
    return this.pending.get(conflictKey);
  }

  tryAdd(conflictKey: string, name: string, existingId?: number, existingSubtypeId?: number): boolean {
    if (this.pending.has(conflictKey)) return false;
    this.pending.set(conflictKey, { name, existingId, existingSubtypeId });
    return true;
  }

  delete(conflictKey: string): void {
    this.pending.delete(conflictKey);
  }

  markResolution(conflictKey: string, resolution: DuplicateResolution): void {
    const entry = this.pending.get(conflictKey);
    if (entry) entry.resolution = resolution;
  }

  findKeyByName(name: string | undefined, resolution?: DuplicateResolution): string | undefined {
    if (!name) return undefined;
    for (const [key, entry] of this.pending) {
      if (entry.name === name && (!resolution || entry.resolution === resolution)) return key;
    }
    return undefined;
  }
}
